export const getExecutionsPerLead = `
query AutomationExecutions(
  $leadUuid: String,
  $limit: Int,
  $offset: Int
) {
  automationExecutions(
    leadUuid: $leadUuid,
    limit: $limit,
    offset: $offset
  ) {
    automationExecutions {
      id
      startsAt
      automation {
        id
        name
      }
    }
    totalCount
    limit
    offset
  }
}
`;

export type GetExecutionsPerLeadResponse = {
  automationExecutions: {
    automationExecutions: {
      id: string;
      startsAt: string;
      automation: {
        id: string;
        name: string;
      };
    }[];
    totalCount: number;
    limit: number;
    offset: number;
  };
};
